import { withProductElementContext } from '@brytdesigns/shopify-product-info-components';
import { createEffect, createMemo, on, onCleanup } from 'solid-js';

(() => {
  const inputs = document.querySelectorAll("input[name='product-id']");

  console.log(`inputs found: ${inputs.length}`);

  if (inputs.length < 1) {
    console.error("no input[name='product-id' found");
    return;
  }

  const productInfo = document.querySelector(`product-info`);
  if (!productInfo) {
    console.error('product info not found');
    return;
  }

  const reviews = document.getElementById('collection-product-reviews-wrapper');
  if (!reviews) {
    console.warn('reviews section not found');
  }

  const getActiveVariantContainer = () => {
    const isMobile = window.matchMedia('(max-width: 575.98px)').matches;
    return isMobile ? document.querySelector('#variantContainerMobile') : document.querySelector('#variantContainer');
  };

  const selectFirstVariantForCurrentProduct = () => {
    const container = getActiveVariantContainer();
    if (!container) return;
    const firstRadio = container.querySelector("input[name='variant-radio']");
    if (firstRadio) {
      firstRadio.checked = true;
      firstRadio.dispatchEvent(new Event('change'));
    }
  };

  withProductElementContext(
    () => productInfo,
    () => null,
    (context) => {
      const [state, methods] = context;
      const productId = createMemo(() => state.product.id);

      createEffect(
        on(productId, (_productId) => {
          const desktopVariantContainers = document.querySelectorAll('.variant-container-templates');
          const mobileVariantContainer = document.getElementById('variantContainerMobile');
          const productContainerSlider = document.getElementById('productContainerSlider');
          const productContainerMobile = document.getElementById('productContainerMobile');

          const controller = new AbortController();

          // Get the currently selected variant radio
          const getSelectedVariantRadio = () => {
            const container = document.getElementById('variantContainer');
            const containerMobile = document.getElementById('variantContainerMobile');
            const mobileMatch = window.matchMedia('(max-width: 767px)').matches;
            if (mobileMatch && containerMobile) {
              return containerMobile.querySelector('input[name="variant-radio"]:checked');
            } else if (container) {
              return container.querySelector('input[name="variant-radio"]:checked');
            }
            return null;
          };

          // Update max quantity based on selected variant
          const updateQuantityMax = () => {
            const qtySelector = document.querySelector('quantity-selector');
            if (!qtySelector) return;

            const selectedRadio = getSelectedVariantRadio();
            if (!selectedRadio) return;

            const isAvailable = selectedRadio.getAttribute('data-available') !== 'no';
            if (!isAvailable) {
              qtySelector.setAttribute('max', '0');
              return;
            }

            const maxQty = Math.min(parseInt(selectedRadio.getAttribute('data-max') || '1'), 10);
            qtySelector.setAttribute('max', maxQty.toString());
          };

          // Show or hide the Add to Cart button based on availability
          const updateATCVisibility = () => {
            const selectedRadio = getSelectedVariantRadio();
            if (!selectedRadio) return;

            const notAvailable = selectedRadio.getAttribute('data-available') === 'no';
            const qtySelectors = document.querySelectorAll('.quantitySelector');
            const BisTrigger = document.getElementById('BIS_trigger');
            const addToCartBtn = document.getElementById('colTwoATC');

            if (addToCartBtn) {
              addToCartBtn.style.display = notAvailable ? 'none' : 'block';
              addToCartBtn.disabled = notAvailable;
            }

            if (BisTrigger) {
              BisTrigger.style.display = notAvailable ? 'block' : 'none';
            }

            qtySelectors.forEach((selector) => {
              selector.style.display = notAvailable ? 'none' : 'block';
            });
          };

          // TODO: this is not doing anything...
          const onChange = (evt) => {
            if (evt?.target?.name === 'variant-radio') {
              methods.variant.update(evt.target.value);
              updateATCVisibility();
              updateQuantityMax();
            }
          };

          const onStarClick = (evt) => {
            if (evt.target.closest('.prodStars')) {
              evt.preventDefault();
              const input = evt.target.closest('label').previousElementSibling;
              input.checked = true;
              input.dispatchEvent(new Event('change', { bubbles: true }));

              if (reviews) {
                requestAnimationFrame(() => {
                  const headerOffset = 94;
                  const elementPosition = reviews.getBoundingClientRect().top;
                  const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
                  window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth',
                  });
                });
              }
            }
          };

          for (let desktopVariantContainer of Array.from(desktopVariantContainers)) {
            desktopVariantContainer?.addEventListener('change', onChange, { signal: controller.signal });
          }
          mobileVariantContainer?.addEventListener('change', onChange, { signal: controller.signal });

          addInputChangeListener(productContainerSlider, controller);
          addInputChangeListener(productContainerMobile, controller);

          for (let productContainer of Array.from(productContainerSlider.children)) {
            productContainer?.addEventListener('click', onStarClick, { signal: controller.signal, capture: true });
          }
          productContainerMobile?.addEventListener('click', onStarClick, { signal: controller.signal, capture: true });

          setTimeout(() => {
            selectFirstVariantForCurrentProduct();
            updateATCVisibility();
            updateQuantityMax();
          }, 0);

          return onCleanup(() => {
            controller.abort();
          });
        }),
      );
    },
  );

  function htmlEscape(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function addInputChangeListener(container, abortController) {
    container.addEventListener(
      'change',
      function (evt) {
        const productId = evt.target.value;
        const scriptTag = document.querySelector(`script[product-id="${productId}"]`);

        if (!scriptTag) {
          console.error(`Script tag not found for productId: ${productId}`);
          return;
        }

        // Get the JSON from the script tag's textContent (script tags don't have phone number auto-linking)
        const productJSON = scriptTag.textContent.trim();

        try {
          const parsed = JSON.parse(productJSON);
          const escapedJSON = htmlEscape(productJSON);
          productInfo.setAttribute('product', escapedJSON);
        } catch (err) {
          console.error(`JSON parse failed: productId: ${productId}`, err);
        }
      },
      {
        signal: abortController.signal,
      },
    );
  }

  if (inputs.length > 0) {
    const isMobile = window.matchMedia('(max-width: 575.98px)').matches;
    let defaultInput = null;

    if (isMobile) {
      const mobileProductContainer = document.querySelector('#productContainerMobile');
      defaultInput = mobileProductContainer?.querySelector("input[name='product-id']") || null;
    }

    if (!defaultInput) {
      const desktopProductContainer = document.querySelector('#productContainer');
      defaultInput = desktopProductContainer?.querySelector("input[name='product-id']") || inputs[0];
    }

    if (defaultInput) {
      defaultInput.checked = true;
      defaultInput.dispatchEvent(new Event('change'));
    }
  }
})();
